module.exports = __webpack_public_path__ + "img/tpc-35.e6132cad.webp";